<template>
  <confirmationModal
    v-bind="$attrs"
    v-on="$listeners"
    :title="`Are you sure you wand to discard changes to ${discardClient.clientId}?`"
    @closeModal="closeModal"
  >
    <p class="subtitle-1">
      This action will discard all changes committed and restore the last promoted change.
    </p>
    <template #buttons>
      <qvoButton text @click="closeModal">Cancel</qvoButton>
      <qvoButton @click="discard">Yes, discard</qvoButton>
    </template>
  </confirmationModal>
</template>
    
<script>
import { mapGetters } from "vuex";

import qvoButton from "@/qux-common/qux22/components/molecules/button";
import confirmationModal from "@/components/confirmation-modal";

export default {
  name: "PromoteConfirmation",
  components: {
    confirmationModal,
    qvoButton,
  },
  methods: {
    closeModal() {
      this.$emit("closeModal");
    },
    discard() {
        const { clientId, clientInfoRuleId, version, changeTitle, changeDetails} = this.discardClient;
        this.$emit("closeModal");
        this.$store.dispatch("restoreChange", {
            ClientId: clientId,
            ClientInfoRuleId: clientInfoRuleId,
            Version: version,
            ChangeTitle: changeTitle,
            ChangeDetails: changeDetails
        });
    },
  },
  computed: {
    ...mapGetters({
      discardClient: "getDiscardClient",
    }),
  },
};
</script>
    
<style lang="scss" scoped>
</style>
